import React, { useState, useEffect, useRef, useContext } from "react";
import Grid from "@mui/material/Grid2";
import {
  Modal,
  Button,
  Box,
  Typography,
  TextField,
  Stack,
  Divider,
  List,
  ListItem,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {
  Stage,
  Layer,
  Text,
  Circle,
  Group,
  Rect,
  Image,
  Label,
  Tag,
} from "react-konva";
import useImage from "use-image";
import location_1 from "../../../asset/location_1.png";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import worker_7 from "../../../asset/worker_7.png";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Api from "../../../Api/Api";
import { TreeSelect } from "antd";
import dayjs from "dayjs";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { DataContext } from "../../../Context/LocDataContext";
import Loader from "../../../Components/Loading";

const Title = (props) => {
  // console.log('render')
  return <Typography>{props.title}</Typography>;
};

var SCENE_BASE_WIDTH = 1000;
var SCENE_BASE_HEIGHT = SCENE_BASE_WIDTH / 2;

const styles1 = {
  Typography1: {
    color: "#ffffff",
    fontFamily: "Noto Sans KR",
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "28.96px",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },
  Typography2: {
    color: "#ffffff",
    fontFamily: "Montserrat",
    fontSize: "10px",
    fontWeight: 600,
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },

  Typography3: {
    color: "#ffffff",
    fontFamily: "Montserrat",
    fontSize: "13px",
    fontWeight: 600,
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },

  Box1: {
    display: "flex",
    justifyContent: "center",
    alignItem: "center",
    width: "100%",
    height: 122,
    background: "#171821",
    boxShadow: "3px 3px 4px 0px #00000099",
  },
  grid1: {
    backdropFilter: "blur(53px)",
    boxShadow: "-8px 4px 5px 0px #0000003d",
    borderRadius: "10px",
    background:
      "linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 15.98%, rgba(0, 0, 0, 0) 36.28%)",
    border: "1px solid #afafaf",
    borderImageSource:
      "linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)",
  },
  Select1: {
    "& label": {
      color: "#e4e4e7",
    },
    ".MuiOutlinedInput-notchedOutline": {
      borderColor: "#afafaf",
      opacity: 0.8,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#afafaf",
      borderWidth: "1px",
      opacity: 0.8,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#afafaf",
      borderWidth: "1px",
    },
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
    },
    "& .MuiInputBase-input": {
      color: "#ffffff",
    },
    "&:hover .MuiInputBase-input": {
      borderColor: "#afafaf",
      borderWidth: "1px",
      opacity: 0.8,
    },
    "&.Mui-focused .MuiInputBase-input": {
      borderColor: "#afafaf",
      borderWidth: "1px",
    },

    color: "#ffffff",
    backdropFilter: "blur(53px)",
    boxShadow: "-8px 4px 5px 0px #0000003d",
    borderRadius: "10px",
    background: "#171821",
    // border: '1px solid #afafaf',
    // borderImageSource:
    //   'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
};

function useInterval(callback, delay) {
  const savedCallback = useRef();
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  React.useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const LionImage2 = (param) => {
  const [image] = useImage(param.param);

  return (
    <Image image={image} width={SCENE_BASE_WIDTH} height={SCENE_BASE_HEIGHT} />
  );
};

export default function SceneStats() {
  const [PreviousBF, setPreviousBF] = useState("");

  const { inputOrgid, setInputOrgid, inputLoid, setInputLoid } =
    useContext(DataContext);
  const [OrgData, setOrgData] = useState([]);
  const [selectedRow, setSelectedRow] = useState();
  const [locationList, setLocationList] = useState([]);
  // const [inputOrgid, setInputOrgid] = useState("");
  // const [inputLoid, setInputLoid] = useState("");
  const [realTimeDate, setRealTimeData] = useState("");
  const [jobLatest, setJobLatest] = useState({});
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [checkValue, setCheckValue] = React.useState(false);
  // const navigate = useNavigate()
  // const match = useMatch('/User/DashBoard/SceneStats/:Orgid/:Loid')

  // console.log('SceneStats match:', match)

  //초기화면 진입시 최상단 스크롤
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCheckChange = (event) => {
    console.log("handleCheckChange:", event.target.checked);
    setCheckValue(event.target.checked);
  };

  useEffect(() => {
    if (inputOrgid === undefined || inputOrgid === null || inputOrgid === "") {
      setInputOrgid("1110");
    }
    if (inputLoid === undefined || inputLoid === null || inputLoid === "") {
      setInputLoid("62d26fb0");
    }
    Org();
  }, []);

  useInterval(() => {
    RealTimeDataFun();
  }, 2000);

  useEffect(() => {
    getLocationList();
  }, [inputOrgid]);

  useEffect(() => {
    jobListOneRowLatest();
  }, [inputLoid]);

  //실시간 데이터
  // const RealTimeDataFun = async () => {
  //   try {
  //     const response = await Api.get(
  //       `api/v1/rt/?orgid=${inputOrgid}&loid=${inputLoid}`
  //     );
  //     if (response.status === 200) {
  //       setRealTimeData(response.data);
  //     }
  //     console.log("RealTimeDataFun response.data", response.data);
  //   } catch (e) {
  //     console.log("RealTimeData exception", e);
  //   }
  // };

  // 실시간 데이터
  const RealTimeDataFun = async () => {
    try {
      const response = await Api.get(
        `api/v1/rt/?orgid=${inputOrgid}&loid=${inputLoid}`
      );
      if (response.status === 200) {
        const newData = response.data;
      
        newData.pls.forEach((place) => {
          place.workers.forEach((worker) => {
            worker.device.forEach((device) => {
              if (device.deviceData) {
                const [key, value] = device.deviceData.split(",").map((s) => s.trim());
                if (key === "heartrate") device.heartrate = value;
                if (key === "emergency") device.emergency = value;
              }
            });
          });
        });
      
        setRealTimeData(newData);
      }
      console.log("RealTimeDataFun response.data", response.data);
    } catch (e) {
      console.log("RealTimeData exception", e);
    }
  };

  const jobListOneRowLatest = async () => {
    setJobLatest();
    const now = dayjs().format("YYYY-MM-DD HH:mm");
    // console.log('jobListOneRowLatest now', now)

    try {
      const response = await Api.get(
        `api/v1/job/getJobByDate/single?date=${now}&loid=${inputLoid}`
      );

      if (response.status === 200) {
        setJobLatest(response.data);
        console.log("jobListOneRowLatest response.data", response.data);
      }
    } catch (e) {
      console.log("jobListOneRowLatest exception", e);
    }
  };

  //부서 리스트
  const Org = async () => {
    try {
      const response = await Api.get("/api/v1/orgn");
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        setOrgData(response.data);
      }
      // console.log('response.data', response.data)
    } catch (e) {
      console.log("Org exception", e);
    }
  };
  //시설 리스트
  const getLocationList = async () => {
    setLoadingFlag(true);
    setJobLatest();
    const headers = {
      istree: true,
    };
    try {
      const response = await Api.get(`/api/v1/loca/?orgz_id=${inputOrgid}`, {
        headers: headers,
      });

      if (response.status === 200) {
        console.log("getLocationList:", response.data);
        let tempList = response.data;
        let tempList2 = response.data;
        tempList.map((item) => {
          if (
            item.dvloc !== null &&
            item.dvloc !== undefined &&
            item.dvloc !== ""
          ) {
            const find1 = tempList2.findIndex((element, index, array) => {
              return element.loid === item.loid;
            });
            tempList2[find1].dvloc = JSON.parse(item.dvloc);
          }
          if (item.loid === inputLoid) {
            setSelectedRow(item);
          }
        });

        console.log("getLocationList inputLoid:", inputLoid);
        // setSelectedRow(tempList2[find1])
        setLocationList(tempList2);
        console.log("getLocationList tempList:", tempList);
        console.log("getLocationList tempList2:", tempList2);
        setLoadingFlag(false);
      }
      // console.log('response.data Users', response.data)
    } catch (e) {
      setLoadingFlag(false);
      console.log("getLocationList exception", e);
    }
  };

  const [size, setSize] = React.useState({
    width: SCENE_BASE_WIDTH,
    height: SCENE_BASE_HEIGHT,
  });
  const layerRef = React.useRef();
  const boxRef = React.useRef();

  useEffect(() => {
    if (boxRef.current?.offsetHeight && boxRef.current?.offsetWidth) {
      setSize({
        width: boxRef.current.offsetWidth,
        height: boxRef.current.offsetWidth / 2,
      });
    }
  }, []);

  React.useEffect(() => {
    const checkSize = () => {
      const colEl = document.querySelector(".konva_box");
      setSize({
        width: colEl.offsetWidth,
        height: colEl.offsetWidth / 2,
      });
    };

    window.addEventListener("resize", checkSize);
    return () => window.removeEventListener("resize", checkSize);
  }, []);

  // mark
  const LionImage = ({ param }) => {
    let resutl = "";
    if (param !== undefined && param !== null && param !== "") {
      resutl = param.bf;
      setPreviousBF(param.bf);
      setInputLoid(param.loid);
      console.log("LionImage param:", param);
    }
    const [image] = useImage(resutl);

    return (
      <Image
        image={image}
        width={SCENE_BASE_WIDTH}
        height={SCENE_BASE_HEIGHT}
      />
    );
  };

  // const LionImage2 = () => {
  //   const [image] = useImage(PreviousBF)

  //   return <Image image={image} width={SCENE_BASE_WIDTH} height={SCENE_BASE_HEIGHT} />
  // }

  const scale1 = size.width / SCENE_BASE_WIDTH;

  const ClickArrowForward = () => {
    const find1 = locationList.findIndex((element, index, array) => {
      return element.loid === selectedRow.loid;
    });
    console.log("ClickArrowForward find1:", find1);
    if (locationList.length - 1 > find1) {
      return setSelectedRow(locationList[find1 + 1]);
    }
  };
  const ClickArrowBack = () => {
    const find1 = locationList.findIndex((element, index, array) => {
      return element.loid === selectedRow.loid;
    });
    console.log("ClickArrowBack find1:", find1);
    if (0 < find1) {
      return setSelectedRow(locationList[find1 - 1]);
    }
  };

  const workerCount = (param) => {
    if (
      realTimeDate !== undefined &&
      realTimeDate !== null &&
      realTimeDate !== "" &&
      realTimeDate
    ) {
      const find1 = realTimeDate.pls.findIndex((element, index, array) => {
        return element.netDeviceId === param;
      });
      if (find1 > -1) {
        const result_count = realTimeDate.pls[find1].worker_count;
        if (
          result_count !== undefined &&
          result_count !== null &&
          result_count !== ""
        ) {
          // console.log("result_count:",result_count)
          return result_count.toString();
        }
      }
    }
  };

  const workerCountTotal = () => {
    let totalNum = 0;

    if (
      realTimeDate !== undefined &&
      realTimeDate !== null &&
      realTimeDate !== "" &&
      realTimeDate
    ) {
      realTimeDate.pls.map((item) => {
        totalNum += item.worker_count;
      });
      return totalNum;
    }
  };

  const NetdeviceStatus = (param) => {
    if (
      realTimeDate !== undefined &&
      realTimeDate !== null &&
      realTimeDate !== "" &&
      realTimeDate
    ) {
      const find1 = realTimeDate.pls.findIndex((element, index, array) => {
        return element.netDeviceId === param;
      });
      if (find1 >= 0) {
        const result_status = realTimeDate.pls[find1].status;

        if (result_status !== undefined && result_status !== null) {
          return result_status;
        }
      }
    }
  };

  const findOrglist = () => {
    if (
      locationList !== undefined &&
      locationList !== null &&
      locationList !== "" &&
      locationList
    ) {
      const find1 = locationList.findIndex((element, index, array) => {
        return element.loid === inputLoid;
      });
      if (find1 >= 0) {
        const result = locationList[find1].orglist.map((item, index) =>
          index === locationList[find1].orglist.length - 1
            ? `${item}`
            : `${item}>`
        );

        if (result !== undefined && result !== null) {
          // console.log('findOrglist result:', result)
          return result;
        }
      }
    }
  };

  // 모달 추가 코드
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [deviceStatus, setDeviceStatus] = useState(null);
  const [deviceStatusType, setDeviceStatusType] = useState(null);
  // const [prevStatus, setPrevStatus] = useState(null)
  const [showStatusChange, setShowStatusChange] = useState(false);
  const [hasOpenedModalOnce, setHasOpenedModalOnce] = useState(false);
  const [prevFullStatus, setPrevFullStatus] = useState(null);

  const fetchDeviceAccidentType = async (device) => {
    try {
      const response = await Api.get(
        `/api/v1/statistics/get_statistics/by_date?orgid=${inputOrgid}&loid=${inputLoid}&startDate=${startDate}&endDate=${endDate}&page=1&size=10`
      );

      if (response.status === 200) {
        const logs = Array.isArray(response.data)
          ? response.data
          : response.data.logs;
        console.log("응답된 로그:", logs);
        console.log("응답된 로그 수:", logs.length);

        const filteredLogs = logs
          .filter((log) => log.di === device.deviceId)
          .sort((a, b) => new Date(b.udt) - new Date(a.udt));
        console.log("🧩 필터링된 디바이스 로그:", filteredLogs);

        if (filteredLogs.length === 0) {
          setDeviceStatusType("연결없음");
          return;
        }

        // 워치
        if (device.deviceName?.includes("워치")) {
          const statusMap = {};

          for (const log of filteredLogs) {
            const [key, value] = log.data_type.split(",").map((s) => s.trim());
            if (!statusMap[key]) {
              statusMap[key] = value;
            }
            if (statusMap["heartrate"] && statusMap["emergency"]) break;
          }

          const merged = Object.entries(statusMap)
            .map(([k, v]) => `${k}, ${v}`)
            .join("; ");
          setDeviceStatusType(merged || "정보 없음");
          return;
        }

        // 그 외 장비
        setDeviceStatusType(filteredLogs[0].data_type);
      }
    } catch (e) {
      console.error("fetchDeviceAccidentType error:", e);
      setDeviceStatusType("조회 실패");
    }
  };

  const handleStatusClick = (device, workerName) => {
    setSelectedDevice({ ...device, workerName });
    setDeviceStatus(device.deviceStatus);

    if (device.deviceStatus === false) {
      setDeviceStatusType("연결없음");
    } else {
      setDeviceStatusType(device.deviceData || "");
    }
  
    setModalOpen(true);
    setHasOpenedModalOnce(true);
  
    if (device.deviceStatus === true) {
      fetchDeviceAccidentType(device);
    }
  };

  const abnormalTypes = ["Crush", "Dump", "Fall"];
  const normalTypes = ["Idle", "Walk", "Work"];
  const watchTypes = ["heartrate", "emergency"];

  const getDeviceStatus = () => {
    if (!selectedDevice) return "정보 없음";
    if (selectedDevice.deviceStatus === false) return "연결없음";

    const keyword = deviceStatusType.split(",")[0].trim();

    if (selectedDevice?.deviceName?.includes("가스")) {
      return deviceStatusType;
    }

    if (abnormalTypes.includes(keyword)) return deviceStatusType;
    if (normalTypes.includes(keyword)) return deviceStatusType;
    if (watchTypes.includes(keyword)) return deviceStatusType;

    return "정보 없음";
  };

  // 병합된 deviceStatusType를 파싱하여 key: value 형태로 변환
  const parseDeviceStatus = () => {
    const statusMap = {};

    if (!deviceStatusType) return statusMap;

    const entries = deviceStatusType.split(";").map((entry) => entry.trim());

    for (const entry of entries) {
      const [key, value] = entry.split(",").map((v) => v.trim());
      if (key && value !== undefined) {
        statusMap[key] = value;
      }
    }

    return statusMap;
  };

  // parseDeviceStatus를 통해 얻은 key에 해당하는 value를 가져옴
  const getTestWatchValue = (key) => {
    const statusMap = parseDeviceStatus();
    const value = statusMap[key];
    return value != null && value !== "" ? value : "";
  };

  // 안전모 위험 상태 감지
  const helmetDanger = (device) => {
    if (!device.deviceData) return false;
    const keyword = device.deviceData.split(",")[0]?.trim();
    return abnormalTypes.includes(keyword);
  };

  // 워치 위험 상태 감지
  const watchDanger = (device) => {
    const hrRaw = device.heartrate;
    const emRaw = device.emergency;
  
    const hr = parseInt(hrRaw);
    const isRiskHR = !isNaN(hr) && hr >= 100;
    const isEmergency = emRaw === "1";

    return isRiskHR || isEmergency;
  };

  // 가스검침기 데이터 구분
  const parseGasData = (dataTypeStr) => {
    if (!dataTypeStr) return [];

    const values = dataTypeStr.split(",").map((v) => parseFloat(v.trim()));
    const gasLabels = ["이산화탄소", "일산화탄소", "산소", "이산화황"];
    const dangerLimits = [700, 200, null, 10];

    return values.map((value, index) => {
      const label = gasLabels[index];
      const limit = dangerLimits[index];
  
      const isDanger = limit != null && value >= limit;
      if (modalOpen && selectedDevice?.deviceName?.includes("가스")) {
        console.log(`${label}: ${value}`);
      }
  
      return {
        label,
        value,
        isDanger,
        text: isDanger ? `${label} 위험` : `${label}: ${value}`,
      };
    });
  };

  // 가스 위험 상태 감지
  const gasDanger = (device) => {
    const parsed = parseGasData(device.deviceData);
    return parsed.some((item) => item.isDanger);
  };

  // 데이터 불러오기 시점 설정(lookupstats 코드 참고)
  useEffect(() => {
    const today = new Date();
    const lastWeek = new Date();
    lastWeek.setDate(today.getDate() - 7);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setEndDate(formatDate(today));
    setStartDate(formatDate(lastWeek));
  }, []);

  // 실시간 데이터 조회
  useEffect(() => {
    let interval;

    if (modalOpen && selectedDevice) {
      interval = setInterval(() => {
        fetchDeviceAccidentType(selectedDevice);
      }, 3000);
    }

    return () => clearInterval(interval);
  }, [modalOpen, selectedDevice, deviceStatusType]);

  // 상태 변경 알림
  useEffect(() => {
    if (!deviceStatusType || !hasOpenedModalOnce) return;

    const isHelmet =
    selectedDevice?.deviceName &&
    !selectedDevice.deviceName.includes("워치") &&
    !selectedDevice.deviceName.includes("가스");

  if (isHelmet && prevFullStatus && prevFullStatus !== deviceStatusType) {
    setShowStatusChange(true);
    setTimeout(() => setShowStatusChange(false), 3000);
  }

    setPrevFullStatus(deviceStatusType);
  }, [deviceStatusType]);

  //
  // useEffect(() => {
  //   if (!modalOpen || !selectedDevice) return;
  //   if (selectedDevice.deviceStatus === false) {
  //     setDeviceStatus("연결없음");
  //     return;
  //   }
  
  //   const name = selectedDevice.deviceName || "";
  //   const statusMap = parseDeviceStatus();
  
  //   if (name.includes("워치")) {
  //     const hr = parseInt(statusMap["heartrate"]);
  //     const em = statusMap["emergency"];
  //     const isRiskHR = !isNaN(hr) && hr >= 90;
  //     const isEmergency = em === "1";
  //     setDeviceStatus(isRiskHR || isEmergency ? "이상" : "정상");
  //   } else if (name.includes("가스")) {
  //     const parsed = parseGasData(deviceStatusType);
  //     const hasDanger = parsed.some((item) => item.isDanger);
  //     setDeviceStatus(hasDanger ? "이상" : "정상");
  //   } else {
  //     const keyword = deviceStatusType.split(",")[0]?.trim();
  //     const isAbnormal = abnormalTypes.includes(keyword);
  //     setDeviceStatus(isAbnormal ? "이상" : "정상");
  //   }
  // }, [modalOpen, selectedDevice, deviceStatusType]);  

  useEffect(() => {
    if (modalOpen) {
      console.log("📌 deviceStatus:", deviceStatus);
    }
  }, [modalOpen, deviceStatus]);

  return (
    <div>
      <Grid container spacing={2} sx={{ marginLeft: 3, marginRight: 3 }}>
        <Grid size={12}>
          <Grid container spacing={1}>
            <Grid size={12} sx={{ marginLeft: 3.5 }}>
              <Box sx={{ width: 300 }}>
                <TreeSelect
                  className="treeSelect"
                  suffixIcon={<ArrowDropDownIcon />}
                  style={{ marginTop: -22 }}
                  value={inputOrgid}
                  dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                  treeData={OrgData}
                  treeTitleRender={(item) => {
                    return <Title title={item.orgn} />;
                  }}
                  fieldNames={{ labal: "orgid", key: "orgid", value: "orgid" }}
                  placeholder="부서 선택"
                  treeDefaultExpandAll
                  onChange={(e) => setInputOrgid(e)}
                />
              </Box>
            </Grid>
            <Grid size={8}>
              <Grid container spacing={5} sx={{ padding: 3.5 }}>
                <Grid size={12} sx={[styles1.grid1, { height: 1 }]}>
                  <Grid container>
                    <Grid
                      size={6}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={[
                          styles1.Typography1,
                          { fontSize: 20, fontWeight: 700, marginLeft: 2 },
                        ]}
                      >
                        실시간 현장 모니터링
                      </Typography>
                    </Grid>
                    <Grid
                      size={6}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: 2,
                      }}
                    >
                      <Box
                        sx={{
                          height: 19,
                          width: 19,
                          borderRadius: "50%",
                          background: "#182AEF",
                          marginRight: 1,
                        }}
                      ></Box>
                      <Typography
                        sx={[
                          styles1.Typography1,
                          { fontSize: 14, fontWeight: 500, marginRight: 3 },
                        ]}
                      >
                        게이트웨이
                      </Typography>
                      <Box
                        sx={{
                          height: 19,
                          width: 19,
                          borderRadius: "50%",
                          background: "#FF8A04",
                          marginRight: 1,
                        }}
                      ></Box>
                      <Typography
                        sx={[
                          styles1.Typography1,
                          { fontSize: 14, fontWeight: 500 },
                        ]}
                      >
                        중계기
                      </Typography>
                    </Grid>
                  </Grid>

                  <Typography
                    sx={[
                      styles1.Typography1,
                      {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: 20,
                        fontWeight: 500,
                      },
                    ]}
                  >
                    {selectedRow ? selectedRow.lon : ""}
                  </Typography>
                  <Grid size={12}>
                    {loadingFlag === true ? (
                      <>
                        <Loader loading={loadingFlag} />
                      </>
                    ) : (
                      <div
                        style={{
                          padding: 17,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          className="konva_box"
                          ref={boxRef}
                          sx={{
                            width: 1,
                            height: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            justifyItems: "center",
                          }}
                        >
                          <Stage
                            width={size.width}
                            height={size.height}
                            scaleX={scale1}
                            scaleY={scale1}
                          >
                            <Layer ref={layerRef}>
                              {selectedRow !== undefined &&
                              selectedRow.bf !== undefined &&
                              PreviousBF !== selectedRow.bf ? (
                                <LionImage param={selectedRow}></LionImage>
                              ) : (
                                <LionImage2 param={PreviousBF}></LionImage2>
                              )}
                              {/* <LionImage param={selectedRow}></LionImage> */}
                              {selectedRow !== undefined &&
                              selectedRow.dvloc !== null &&
                              selectedRow.dvloc
                                ? selectedRow.dvloc.map((star, index) => (
                                    <Group
                                      key={star.di}
                                      id={star.di}
                                      x={star.x}
                                      y={star.y}
                                    >
                                      <Circle
                                        radius={20}
                                        fill={
                                          star.dsi === "Gateway" &&
                                          NetdeviceStatus(star.di)
                                            ? "#182AEF"
                                            : star.dsi === "Repeater" &&
                                                NetdeviceStatus(star.di)
                                              ? "#FF8A04"
                                              : "#ffffff"
                                        }
                                        opacity={0.9}
                                        shadowColor="black"
                                        shadowBlur={10}
                                        shadowOpacity={0.6}
                                        onDblClick={() => console.log(star)}
                                      />
                                      {checkValue === false ? (
                                        <Label x={0} y={-25}>
                                          <Tag
                                            fill="black"
                                            pointerDirection="down"
                                            pointerWidth={10}
                                            pointerHeight={10}
                                            lineJoin="round"
                                            shadowColor="black"
                                            shadowBlur={10}
                                            shadowOffsetX={10}
                                            shadowOffsetY={10}
                                            shadowOpacity={0.5}
                                          ></Tag>
                                          <Text
                                            text={`${star.dname}`}
                                            fontFamily="Calibri"
                                            fontSize={18}
                                            padding={5}
                                            fill="white"
                                          />
                                        </Label>
                                      ) : (
                                        ""
                                      )}

                                      <Text
                                        text={
                                          workerCount(star.di) === undefined
                                            ? "n"
                                            : `${workerCount(star.di)}`
                                        }
                                        fill="#ffffff"
                                        wrap="char"
                                        align="center"
                                        fontSize={25}
                                        x={-6}
                                        y={-11}
                                      />
                                    </Group>
                                  ))
                                : ""}
                            </Layer>
                          </Stage>
                        </Box>
                      </div>
                    )}
                  </Grid>
                  <Grid
                    size={12}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        justifyItems: "center",
                        alignItem: "center",
                        alignContent: "center",
                      }}
                    >
                      <Checkbox
                        // defaultChecked
                        onChange={handleCheckChange}
                        checked={checkValue}
                        sx={{
                          color: "#ffffff",
                          "& + .MuiFormControlLabel-label": {
                            color: "#ffffff",
                            fontSize: "12px",
                          },
                          "&.Mui-checked": {
                            color:
                              "linear-gradient(to left, #7CC1F3 0%, #D27EEF 100%)",
                            // "&, & + .MuiFormControlLabel-label": {
                            //   color: "red"
                            // },
                          },
                          display: "flex",
                          justifyContent: "center",
                          alignItem: "center",
                        }}
                      />
                      <Typography
                        sx={[
                          styles1.Typography3,
                          {
                            marginTop: 1.3,
                            marginRight: 2,
                          },
                        ]}
                      >
                        장비명 숨기기
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid
                  size={12}
                  sx={[
                    styles1.grid1,
                    {
                      justifyContent: "center",
                      alignItems: "center",
                      alignContent: "center",
                    },
                  ]}
                >
                  <Stack
                    direction="row"
                    sx={{ justifyContent: "center", alignItems: "center" }}
                  >
                    <Button
                      sx={{ color: "#ffffff" }}
                      onClick={() => ClickArrowBack()}
                    >
                      <ArrowBackIosIcon />
                    </Button>
                    <ImageList
                      sx={{
                        gridAutoFlow: "column",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(130px,1fr)) !important",
                        gridAutoColumns: "minmax(130px, 1fr)",
                      }}
                    >
                      {locationList.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            background: "#171821",
                            boxShadow: "3px 3px 4px 0px #00000099",
                            borderRadius: "3px",
                            ...(item === selectedRow
                              ? { border: "5px solid #ffffff" }
                              : {}),
                          }}
                        >
                          <ImageListItem
                            key={index}
                            onClick={() => {
                              console.log("ImageListItem item:", item);
                              setInputLoid(item.loid);
                              setSelectedRow(item);
                            }}
                            sx={{
                              /* ...restProps  */
                              margin: 2,
                            }}
                          >
                            <img src={item.bf} style={{ height: 130 }} />
                            {/* <ImageListItemBar title={item.lon} /> */}
                          </ImageListItem>
                          <Typography
                            sx={{
                              color: "#ffffff",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginBottom: 2,
                            }}
                          >
                            {item.lon}
                          </Typography>
                        </Box>
                      ))}
                    </ImageList>
                    <Button
                      sx={{ color: "#ffffff" }}
                      onClick={() => ClickArrowForward()}
                    >
                      <ArrowForwardIosIcon />
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid size={4}>
              <Grid container spacing={5} sx={{ padding: 3.5 }}>
                <Grid size={12} sx={[styles1.grid1, { height: 271 }]}>
                  <div style={{ padding: 17 }}>
                    <Typography sx={styles1.Typography1}>현장 정보</Typography>
                    <Typography sx={[styles1.Typography1, { fontSize: 12 }]}>
                      위치 정보
                    </Typography>
                    <Typography
                      sx={[
                        styles1.Typography1,
                        {
                          fontSize: 12,
                          color: "#efefef",
                          border: "0.5px solid #807F88",
                          borderRadius: "6px",
                        },
                      ]}
                    >
                      {/* mark */}
                      &nbsp;&nbsp;{findOrglist()}
                    </Typography>
                    <Typography
                      sx={[styles1.Typography1, { fontSize: 12, marginTop: 1 }]}
                    >
                      현재 작업
                    </Typography>
                    <Typography
                      sx={[
                        styles1.Typography1,
                        {
                          fontSize: 12,
                          color: "#efefef",
                          border: "0.5px solid #807F88",
                          borderRadius: "6px",
                        },
                      ]}
                    >
                      &nbsp;&nbsp;
                      {jobLatest &&
                        `${jobLatest.jn})${jobLatest.sdt}  ~  ${jobLatest.edt}`}
                    </Typography>
                    <Grid container>
                      <Grid size={4}>
                        <Typography
                          sx={[
                            styles1.Typography1,
                            { fontSize: 12, marginTop: 1 },
                          ]}
                        >
                          작업 인원
                        </Typography>
                        <Stack direction="row" spacing={0.6}>
                          <Typography
                            sx={[
                              styles1.Typography1,
                              {
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                                fontSize: 12,
                                width: 40,
                                color: "#efefef",
                                border: "0.5px solid #807F88",
                                borderRadius: "6px",
                              },
                            ]}
                          >
                            {`${workerCountTotal()}`}
                          </Typography>
                          <Typography
                            sx={[
                              styles1.Typography1,
                              { fontSize: 12, color: "#ffffff" },
                            ]}
                          >
                            /
                          </Typography>
                          <Typography
                            sx={[
                              styles1.Typography1,
                              {
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                                fontSize: 12,
                                width: 40,
                                color: "#efefef",
                                border: "0.5px solid #807F88",
                                borderRadius: "6px",
                              },
                            ]}
                          >
                            {jobLatest &&
                            jobLatest.wkl !== undefined &&
                            jobLatest.wkl !== null
                              ? `${jobLatest.wkl.length}`
                              : ""}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid size={8}>
                        {" "}
                        <Typography
                          sx={[
                            styles1.Typography1,
                            { fontSize: 12, marginTop: 1 },
                          ]}
                        >
                          작업 책임자
                        </Typography>
                        <Stack
                          direction="row"
                          sx={[
                            styles1.Typography1,
                            {
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: 12,
                              color: "#efefef",
                              border: "0.5px solid #807F88",
                              borderRadius: "6px",
                            },
                          ]}
                        >
                          <Typography
                            sx={[
                              styles1.Typography1,
                              { fontSize: 12, color: "#efefef" },
                            ]}
                          >
                            &nbsp;&nbsp;{jobLatest && `ID: ${jobLatest.uid}`}
                          </Typography>
                          {/* <Button
                            variant="contained"
                            sx={{
                              marginLeft: 1,
                              fontSize: 11,
                              height: 23,
                              background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%);',
                            }}
                          >
                            자세히
                          </Button> */}
                        </Stack>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid
                  size={12}
                  sx={[styles1.grid1, { height: 470, overflow: "auto" }]}
                >
                  <div style={{ padding: 17 }}>
                    <Typography sx={styles1.Typography1}>
                      모니터링 정보
                    </Typography>
                    {/* {게이트웨이 리스트} */}
                    {realTimeDate &&
                    realTimeDate.pls !== undefined &&
                    realTimeDate.pls !== null
                      ? realTimeDate.pls.map((item, index) => {
                          if (item.dsi === "Gateway") {
                            return (
                              <Grid container key={index} sx={{ marginTop: 2 }}>
                                <Grid
                                  size={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      height: 19,
                                      width: 19,
                                      borderRadius: "50%",
                                      background: "#182AEF",
                                      marginRight: 1,
                                    }}
                                  ></Box>
                                  <Typography
                                    sx={[
                                      styles1.Typography1,
                                      {
                                        fontSize: 14,
                                        fontWeight: 500,
                                        marginRight: 3,
                                      },
                                    ]}
                                  >
                                    {realTimeDate.lon}/{item.netDeviceName}/
                                    {item.status === true ? "정상" : "오프"}
                                  </Typography>
                                </Grid>
                                {item.workers.map((item2, index) => {
                                  return (
                                    <Grid size={12} key={index}>
                                      <Grid
                                        container
                                        direction="row"
                                        sx={{ padding: 1.2 }}
                                      >
                                        <img
                                          style={{ width: 34, height: 34 }}
                                          src={worker_7}
                                        ></img>
                                        <Typography
                                          sx={[
                                            styles1.Typography1,
                                            {
                                              fontSize: 14,
                                              fontWeight: 500,
                                              marginLeft: 1,
                                            },
                                          ]}
                                        >
                                          {item2.workerName}
                                        </Typography>
                                      </Grid>
                                      {item2.device.map((item3, index) => {
                                        const isWatch = item3.deviceName?.includes("워치");
                                        const isGas = item3.deviceName?.includes("가스");
                                        const isDisconnected = item3.deviceStatus === false;

                                        const isDanger =
                                          (isWatch && watchDanger(item3)) ||
                                          (isGas && gasDanger(item3)) ||
                                          (!isWatch && !isGas && helmetDanger(item3));

                                        const circleColor = isDisconnected
                                          ? "#ffffff"
                                          : isDanger
                                          ? "#991010"
                                          : "#2B9910";

                                        const renderStatusButton = () => {
                                          if (isDisconnected) {
                                            return (
                                              <Button
                                                variant="contained"
                                                sx={{
                                                  width: 78,
                                                  color: "#000000",
                                                  fontSize: 11,
                                                  height: 23,
                                                  background: "#ffffff",
                                                  margin: 0.5,
                                                }}
                                                onClick={() => handleStatusClick(item3, item2.workerName)}
                                              >
                                                연결없음
                                              </Button>
                                            );
                                          }

                                          if (isDanger) {
                                            return (
                                              <Button
                                                variant="contained"
                                                sx={{
                                                  width: 78,
                                                  fontSize: 11,
                                                  height: 23,
                                                  background: "#991010",
                                                  margin: 0.5,
                                                }}
                                                onClick={() => handleStatusClick(item3, item2.workerName)}
                                              >
                                                이상
                                              </Button>
                                            );
                                          }

                                          return (
                                            <Button
                                              variant="contained"
                                              sx={{
                                                width: 78,
                                                fontSize: 11,
                                                height: 23,
                                                background: "#2B9910",
                                                margin: 0.5,
                                              }}
                                              onClick={() => handleStatusClick(item3, item2.workerName)}
                                            >
                                              정상
                                            </Button>
                                          );
                                        };

                                        return (
                                          <Stack
                                            key={index}
                                            direction="row"
                                            sx={{ display: "flex", alignItems: "center" }}
                                          >
                                            <Box
                                              sx={{
                                                marginLeft: 3,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  marginLeft: 2,
                                                  borderRadius: 50,
                                                  width: 15,
                                                  height: 15,
                                                  background: circleColor,
                                                }}
                                              />
                                            </Box>

                                            <Stack
                                              direction="row"
                                              sx={[
                                                styles1.Typography1,
                                                {
                                                  width: "100%",
                                                  marginLeft: 1,
                                                  alignItems: "center",
                                                  justifyContent: "space-between",
                                                  fontSize: 12,
                                                  color: "#807F88",
                                                  border: "0.5px solid #454546",
                                                  borderRadius: "6px",
                                                },
                                              ]}
                                            >
                                              <Typography
                                                sx={[styles1.Typography2, { marginLeft: 3 }]}
                                              >
                                                {item3.deviceName}
                                              </Typography>
                                              {renderStatusButton()}
                                            </Stack>
                                          </Stack>
                                        );
                                      })}
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            );
                          }
                          if (item.dsi === "Repeater") {
                            return (
                              <Grid container sx={{ marginTop: 2 }} key={index}>
                                <Grid
                                  size={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      height: 19,
                                      width: 19,
                                      borderRadius: "50%",
                                      background: "#FF8A04",
                                      marginRight: 1,
                                    }}
                                  ></Box>
                                  <Typography
                                    sx={[
                                      styles1.Typography1,
                                      {
                                        fontSize: 14,
                                        fontWeight: 500,
                                        marginRight: 3,
                                      },
                                    ]}
                                  >
                                    {realTimeDate.lon}/{item.netDeviceName}/
                                    {item.status === true ? "정상" : "오프"}
                                  </Typography>
                                </Grid>
                                {item.workers.map((item2, index) => {
                                  return (
                                    <Grid size={12} key={index}>
                                      <Grid
                                        container
                                        direction="row"
                                        sx={{ padding: 1.2 }}
                                      >
                                        <img
                                          style={{ width: 34, height: 34 }}
                                          src={worker_7}
                                        ></img>
                                        <Typography
                                          sx={[
                                            styles1.Typography1,
                                            {
                                              fontSize: 14,
                                              fontWeight: 500,
                                              marginLeft: 1,
                                            },
                                          ]}
                                        >
                                          {item2.workerName}
                                        </Typography>
                                      </Grid>
                                      {item2.device.map((item3, index) => {
                                        const isWatch = item3.deviceName?.includes("워치");
                                        const isGas = item3.deviceName?.includes("가스");
                                        const isDisconnected = item3.deviceStatus === false;

                                        const isDanger =
                                          (isWatch && watchDanger(item3)) ||
                                          (isGas && gasDanger(item3)) ||
                                          (!isWatch && !isGas && helmetDanger(item3));

                                        const circleColor = isDisconnected
                                          ? "#ffffff"
                                          : isDanger
                                          ? "#991010"
                                          : "#2B9910";

                                        const renderStatusButton = () => {
                                          if (isDisconnected) {
                                            return (
                                              <Button
                                                variant="contained"
                                                sx={{
                                                  width: 78,
                                                  color: "#000000",
                                                  fontSize: 11,
                                                  height: 23,
                                                  background: "#ffffff",
                                                  margin: 0.5,
                                                }}
                                                onClick={() => handleStatusClick(item3, item2.workerName)}
                                              >
                                                연결없음
                                              </Button>
                                            );
                                          }

                                          if (isDanger) {
                                            return (
                                              <Button
                                                variant="contained"
                                                sx={{
                                                  width: 78,
                                                  fontSize: 11,
                                                  height: 23,
                                                  background: "#991010",
                                                  margin: 0.5,
                                                }}
                                                onClick={() => handleStatusClick(item3, item2.workerName)}
                                              >
                                                이상
                                              </Button>
                                            );
                                          }

                                          return (
                                            <Button
                                              variant="contained"
                                              sx={{
                                                width: 78,
                                                fontSize: 11,
                                                height: 23,
                                                background: "#2B9910",
                                                margin: 0.5,
                                              }}
                                              onClick={() => handleStatusClick(item3, item2.workerName)}
                                            >
                                              정상
                                            </Button>
                                          );
                                        };

                                        return (
                                          <Stack
                                            key={index}
                                            direction="row"
                                            sx={{ display: "flex", alignItems: "center" }}
                                          >
                                            <Box
                                              sx={{
                                                marginLeft: 3,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  marginLeft: 2,
                                                  borderRadius: 50,
                                                  width: 15,
                                                  height: 15,
                                                  background: circleColor,
                                                }}
                                              />
                                            </Box>

                                            <Stack
                                              direction="row"
                                              sx={[
                                                styles1.Typography1,
                                                {
                                                  width: "100%",
                                                  marginLeft: 1,
                                                  alignItems: "center",
                                                  justifyContent: "space-between",
                                                  fontSize: 12,
                                                  color: "#807F88",
                                                  border: "0.5px solid #454546",
                                                  borderRadius: "6px",
                                                },
                                              ]}
                                            >
                                              <Typography
                                                sx={[styles1.Typography2, { marginLeft: 3 }]}
                                              >
                                                {item3.deviceName}
                                              </Typography>
                                              {renderStatusButton()}
                                            </Stack>
                                          </Stack>
                                        );
                                      })}
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            );
                          }
                        })
                      : ""}

                    {/* {중계기 리스트} */}
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* 모달 추가 코드 */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        {/* 바깥 박스 배경 */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            height: 300,
            bgcolor: "#171821",
            borderRadius: "20px",
            zIndex: 1300,
            overflow: "hidden",
            boxShadow: "-8px 4px 5px 0px #0000003d",
            border: "1px solid #afafaf",
            color: "#ffffff",
          }}
        >
          {/* 효과 레이어 */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backdropFilter: "blur(30px)",
              WebkitBackdropFilter: "blur(30px)",
              background:
                "linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)), " +
                "linear-gradient(321.23deg, rgba(191, 191, 191, 0.062), rgba(0, 0, 0, 0))",
              zIndex: 1,
              pointerEvents: "none",
            }}
          />
          {/* 내용 표시 */}
          <Box
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              zIndex: 2,
            }}
          >
            <IconButton
              aria-label="close"
              onClick={() => setModalOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "#999",
              }}
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="h6" sx={{ mb: "30px" }}>
              장비 상세 정보
            </Typography>

            {showStatusChange &&
              selectedDevice?.deviceName &&
              !selectedDevice.deviceName.includes("워치") && (
                <Typography
                  sx={{
                    color: "#ff4d4f",
                    mt: "-30px",
                    mb: "20px",
                    textAlign: "center",
                  }}
                >
                  상태가 변경되었습니다.
                </Typography>
              )}

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                textAlign: "left",
                width: 235,
                gap: "5px",
                ml: "60px",
              }}
            >
              {selectedDevice && (
                <>
                  {/* 사용자 */}
                  {selectedDevice.workerName && (
                    <Stack direction="row" spacing={0}>
                      <Typography sx={{ width: "80px" }}>사용자</Typography>
                      <Typography sx={{ color: "#999" }}>|</Typography>
                      <Typography sx={{ ml: "20px" }}>
                        {selectedDevice.workerName}
                      </Typography>
                    </Stack>
                  )}
                  {/* 장비 이름 */}
                  <Stack direction="row" spacing={0}>
                    <Typography sx={{ width: "80px" }}>장비 이름</Typography>
                    <Typography sx={{ color: "#999" }}>|</Typography>
                    <Typography sx={{ ml: "20px" }}>
                      {selectedDevice.deviceName}
                    </Typography>
                  </Stack>
                  {/* 상태 */}
                  {/* <Stack direction="row" spacing={0}>
                    <Typography sx={{ width: "80px" }}>상태</Typography>
                    <Typography sx={{ color: "#999" }}>|</Typography>
                    <Typography sx={{ ml: "20px" }}>{getDeviceStatus()}</Typography>
                  </Stack> */}
                  {deviceStatusType === "연결없음" ? (
                    <Stack direction="row" spacing={0}>
                      <Typography sx={{ width: "80px" }}>상태</Typography>
                      <Typography sx={{ color: "#999" }}>|</Typography>
                      <Typography sx={{ ml: "20px" }}>연결없음</Typography>
                    </Stack>
                  ) : selectedDevice.deviceName?.includes("워치") ? (
                    // 워치
                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "stretch" }}>
                      {/* 상태 라벨 */}
                      <Box
                        sx={{
                          width: "80px",
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center"
                        }}
                      >
                        <Typography>상태</Typography>
                      </Box>

                      {/* 세로 구분자 */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center"
                        }}
                      >
                        <Typography sx={{ color: "#999" }}>|</Typography>
                        <Typography sx={{ color: "#999" }}>|</Typography>
                      </Box>

                      {/* 상태 내용 */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          ml: "20px"
                        }}
                      >
                        {(() => {
                          const value = getTestWatchValue("heartrate");
                          let status = "측정 중...";
                          const num = parseInt(value);
                        
                          if (modalOpen && !isNaN(num)) {
                            console.log("💓심박수:", num);
                          }
                        
                          if (!isNaN(num)) {
                            if (num >= 100) status = "위험";
                            else if (num >= 60) status = "정상";
                          }

                          return (
                            <Typography>
                            심박수:{" "}
                            <Box
                              component="span"
                              sx={{ color: status === "위험" ? "#ff4d4f" : "inherit", display: "inline" }}
                            >
                              {status}
                            </Box>
                          </Typography>
                          );
                        })()}

                        {(() => {
                          const value = getTestWatchValue("emergency");

                          if (modalOpen) {
                            console.log("🚨emergency:", value);
                          }

                          if (value === "1") {
                            return (
                              <Typography sx={{ color: "#ff4d4f" }}>
                                비상 버튼 감지
                              </Typography>
                            );
                          }

                          return null;
                        })()}
                      </Box>
                    </Box>
                  ) : selectedDevice.deviceName?.includes("가스") ? (
                    // 가스 검침기
                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                      {/* 상태 라벨 */}
                      <Box sx={{ width: "80px", display: "flex", justifyContent: "flex-start", alignItems: "center", height: "100%" }}>
                        <Typography>상태</Typography>
                      </Box>

                      {/* 세로 구분자 */}
                      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mr: 2 }}>
                        <Typography sx={{ color: "#999", lineHeight: "24px" }}>|</Typography>
                        <Typography sx={{ color: "#999", lineHeight: "24px" }}>|</Typography>
                        <Typography sx={{ color: "#999", lineHeight: "24px" }}>|</Typography>
                      </Box>

                      {/* 상태 내용 */}
                      <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                        {parseGasData(deviceStatusType)
                          .filter((item) => item.label !== "산소")
                          .map((item, idx) => (
                            <Box
                              key={idx}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 1,
                                alignItems: "center",
                                lineHeight: "24px",
                              }}
                            >
                              <Typography>{item.label}:</Typography>
                              <Typography sx={{ color: item.isDanger ? "#ff4d4f" : "inherit" }}>
                                {item.isDanger ? "위험" : "정상"}
                              </Typography>
                            </Box>
                          ))}
                      </Box>
                    </Box>
                  ) : (
                    // 안전모
                    <Stack direction="row" spacing={0}>
                      <Typography sx={{ width: "80px" }}>상태</Typography>
                      <Typography sx={{ color: "#999" }}>|</Typography>
                      <Typography sx={{ ml: "20px" }}>{getDeviceStatus()}</Typography>
                    </Stack>
                  )}
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
